import { render, staticRenderFns } from "./EquipSysMgmtDetail.vue?vue&type=template&id=f87f296c&scoped=true"
import script from "./EquipSysMgmtDetail.vue?vue&type=script&lang=js"
export * from "./EquipSysMgmtDetail.vue?vue&type=script&lang=js"
import style0 from "./EquipSysMgmtDetail.vue?vue&type=style&index=0&id=f87f296c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87f296c",
  null
  
)

export default component.exports